import { render, staticRenderFns } from "./exhibition-card.vue?vue&type=template&id=2bf55a2e&scoped=true&"
import script from "./exhibition-card.vue?vue&type=script&lang=js&"
export * from "./exhibition-card.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-card.vue?vue&type=style&index=0&id=2bf55a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf55a2e",
  null
  
)

export default component.exports